import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserRoleModel} from '../../../../shared/dto/user-role.model';
import {UserRoleCategoryModel} from '../../../../shared/dto/user-role-category.model';
import {UserRoleService} from '../../../../shared/service/userrole.service';
import {UserroleCategoryService} from '../../../../shared/service/userrole-category.service';
import {UserDetailModel} from '../../../../shared/dto/user-detail.model';
import {AuthService} from '../../../../shared/service/auth.service';
import {PatternValidation} from '../../../../shared/enums/pattern-validation.enum';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-system-user-popup',
  templateUrl: './system-user-popup.component.html',
  styleUrls: ['./system-user-popup.component.scss']
})
export class SystemUserPopupComponent implements OnInit {
  public systemUserPopup: FormGroup;
  public name: string;
  public password: string;
  public applicationId: string;
  public selectedMode;
  public userRoles: UserRoleModel [] = [];
  public userRoleCategories: UserRoleCategoryModel [] = [];
  public employeeId: number;
  public systemUsers: UserDetailModel[] = [];

  ActionMode = ActionMode;

  constructor(public activeModal: NgbActiveModal,
              private userRoleService: UserRoleService,
              private userroleCategoryService: UserroleCategoryService,
              private authService: AuthService) { }

  ngOnInit() {
    this.systemUserPopup = new FormGroup({
      name: new FormControl(null,[Validators.required , Validators.pattern(PatternValidation.nameValidation)]),
      password: new FormControl(null,Validators.required),
      userRoleCode: new FormControl(null,Validators.required),
      userRoleCategory: new FormControl(null,Validators.required),
      states: new FormControl(null,Validators.required),
    });
    this.loadUserRoles();
    this.loadUserRoleCategories();
    this.loadSystemUsers();
  }

  loadSystemUsers() {
    this.authService.getSystemUserByName(this.name).subscribe(
      (data: UserDetailModel[]) => {
          this.systemUsers = data;
      }
    );
  }

  loadUserRoles() {
    this.userRoleService.getAllUserRoles().subscribe(
      (data: UserRoleModel[]) => {
        this.userRoles = data;
      }
    );
  }

  loadUserRoleCategories() {
    this.userroleCategoryService.getAllUserRoleCategory().subscribe(
      (data: UserRoleCategoryModel[]) => {
        this.userRoleCategories = data;
      }
    )
  }

  get FormControls() {
    return this.systemUserPopup.controls;
  }

  onSubmit(){
    let isValid: boolean = true;
    let errorMessage: string = '';
    if (isValid) {
      Swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result)=> {
        if(result.value) {
          const userDetailModel: UserDetailModel = new UserDetailModel(
            this.systemUserPopup.value.name,
            this.systemUserPopup.value.password,
            this.systemUserPopup.value.states,
            this.systemUserPopup.value.userRoleCode,
            this.systemUserPopup.value.userRoleCategory,
            this.systemUserPopup.value.name,
            null,
            this.employeeId,
            null,
            null,
            null,
            null,
            null
          );
          this.authService.saveSystemUser(userDetailModel).subscribe(
            (success: string) => {
              Swal.fire("Success", "Details submitted successfully", "success");
            },
            (error) => {
              console.log(error);
              Swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.activeModal.close("Saved");
            }
          );
        }
        }, reason => {
        }
      );
    } else{
      Swal.fire('Error',errorMessage,'error');
    }
  }

}
